<template>
  <div class="d-flex flex-column gap-4" data-testid="yard-tasks">
    <div class="d-flex flex-wrap gap-3 justify-space-between align-center">
      <yard-tasks-view-mode-select data-testid="yard-tasks-view-mode-select" class="ml-auto" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import YardTasksViewModeSelect from '@/modules/yard/components/Selects/YardTasksViewModeSelect.vue';

export default defineComponent({
  name: 'YardTasks',
  components: {
    YardTasksViewModeSelect
  },
  props: {},
  setup() {}
});
</script>
